/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum RollOffReasonCode {
  TalentLeftAxiom = "TalentLeftAxiom",
  TalentLeftEngagement = "TalentLeftEngagement",
  TalentPerformanceIssue = "TalentPerformanceIssue",
  BudgetLost = "BudgetLost",
  CoEmploymentCap = "CoEmploymentCap",
  Conversion = "Conversion",
  CleanUp = "CleanUp",
  TransitionToAnother = "TransitionToAnother",
  ProjectCompleted = "ProjectCompleted",
  WrongFit = "WrongFit",
  FalseStart = "FalseStart",
  Covid19 = "Covid19",
  GapFill = "GapFill",
  MaternityLeave = "MaternityLeave",
  OverForecastingError = "OverForecastingError",
  ProjectDeScoped = "ProjectDeScoped",
  ProjectDefunded = "ProjectDefunded",
}

export const RollOffReasonCodeDisplay: Record<RollOffReasonCode, string> = {
  [RollOffReasonCode.TalentLeftAxiom]: "Talent Left Axiom",
  [RollOffReasonCode.TalentLeftEngagement]: "Talent Left Engagement",
  [RollOffReasonCode.TalentPerformanceIssue]: "Talent Performance Issue",
  [RollOffReasonCode.BudgetLost]: "Budget Lost",
  [RollOffReasonCode.CoEmploymentCap]: "Co Employment Cap",
  [RollOffReasonCode.Conversion]: "Conversion",
  [RollOffReasonCode.CleanUp]: "Clean Up",
  [RollOffReasonCode.TransitionToAnother]: "Transition To Another",
  [RollOffReasonCode.ProjectCompleted]: "Project Completed",
  [RollOffReasonCode.WrongFit]: "Wrong Fit",
  [RollOffReasonCode.FalseStart]: "False Start",
  [RollOffReasonCode.Covid19]: "Covid19",
  [RollOffReasonCode.GapFill]: "Gap Fill",
  [RollOffReasonCode.MaternityLeave]: "Maternity Leave",
  [RollOffReasonCode.OverForecastingError]: "Over Forecasting Error",
  [RollOffReasonCode.ProjectDeScoped]: "Project De Scoped",
  [RollOffReasonCode.ProjectDefunded]: "Project Defunded",
};
